import BlockMoneyCard from './BlockMoneyCard';
export default BlockMoneyCard;
